module.exports = __webpack_public_path__ + "static/img/banner-x.2aa0d9c7.png";